module.exports = __webpack_public_path__ + "static/media/indusauto.11ef58f6.jpg";